/**
 * Website Item Parent mixin
 * Use this in all items that can has both templates or websites as a parent
 * @mixin
 */

export default {
	computed: {
		isTemplate() {
			return !!this.$route.params.template
		},
		parentId() {
			return this.isTemplate ? this.$route.params.template : this.$route.params.website
		},
		parentEndpoint() {
			return this.isTemplate ? 'websitetemplates' : 'websites'
		},
		parentNode() {
			return this.isTemplate ? 'websitetemplate' : 'website'
		},
	},
}
